import {
    AnimationBaseController,
    FullScreenManager,
    IAnimationControllerConfiguration,
    Inject,
} from '@denishussar/html5-game-engine';
import { GameLogic } from '../../Logic/GameLogic';
import { AnimationContents } from '../../../AnimationContents';
import {
    GameModel,
    GameStateEnum,
    TooltipStateEnum,
} from '../../Models/Game/GameModel';
import { UIScoreController } from './UIScoreController';
import { UITaskListController } from './UITaskListController';
import { MiniGameTypeEnum } from '../../Models/Game/MiniGameModel';
import { UIButtonTopController } from './UIButtonTopController';
import { AchievementType } from '../../Models/Game/AchievementModel';
import { UITooltipController } from './UITooltipController';
import { UIPointerBonusController } from './UIPointerBonusController';
import { BonusTypeEnum } from '../../Models/Game/BonusModel';
import { UITimeController } from './UITimeController';
import { UIPointerMiniGameController } from './UIPointerMiniGameController';
import { TaskType } from '../../Models/Game/TaskModel';
import { UIButtonLeftController } from './UIButtonLeftController';

export class UIController extends AnimationBaseController {
    $model: GameModel;

    public constructor(
        @Inject private _options,
        @Inject private _gameLogic: GameLogic,
        @Inject private _fullScreenManager: FullScreenManager
    ) {
        super('UIController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            animationContent: AnimationContents.GAME_SCREEN_JSON,
            libraryName: 'top_panel_container',
            childControllers: {
                UIButtonsTopController: {
                    instanceName: 'buttons_top_menu',
                    view: UIButtonTopController,
                    model: this.$model,
                },
                UIButtonsLeftController: {
                    instanceName: 'buttons_left_menu',
                    view: UIButtonLeftController,
                    model: this.$model,
                },
                UIScoreController: {
                    instanceName: 'score_menu',
                    view: UIScoreController,
                    model: this.$model.player,
                },
                UITimeController: {
                    instanceName: 'time_menu',
                    view: UITimeController,
                    model: this.$model.player,
                },
                UITasksController: {
                    instanceName: 'tasks_menu',
                    view: UITaskListController,
                    model: this.$model,
                },
            },
            modelEvents: {
                addTask: (miniGameType: MiniGameTypeEnum) => {
                    const miniGame =
                        this._gameLogic.getMiniGameByType(miniGameType);
                    this._showGlobalTaskTooltip(miniGameType);

                    if (miniGame) {
                        this.addChildController(
                            {
                                view: UIPointerMiniGameController,
                                model: miniGame,
                            },
                            `pointer_${miniGameType}`,
                            0
                        );
                    }
                },
                removeTask: (miniGameType: MiniGameTypeEnum) => {
                    this.removeChildControllerByName(`pointer_${miniGameType}`);
                },
                addBonus: (bonusType: BonusTypeEnum, roomIndex: number) => {
                    const bonus = this._gameLogic.getBonusByTypeAndRoom(
                        bonusType,
                        roomIndex
                    );

                    console.log('addBonus', bonusType, bonus);

                    if (bonus) {
                        this.addChildController(
                            {
                                view: UIPointerBonusController,
                                model: bonus,
                            },
                            `pointer_${bonusType}_${roomIndex}`,
                            0
                        );
                    }
                },
                removeBonus: (bonusType: BonusTypeEnum, roomIndex: number) => {
                    this.removeChildControllerByName(
                        `pointer_${bonusType}_${roomIndex}`
                    );
                },
                miniGameTimeOver: (miniGameType: MiniGameTypeEnum) => {
                    if (
                        this.$model.taskOptionList.count() === 0 &&
                        this.$model.taskCurrentList.count() === 0
                    ) {
                        this.$childControllers.get(
                            'UITasksController'
                        ).visible = false;
                    }
                },
                miniGameComplete: (miniGameType: MiniGameTypeEnum) => {
                    if (
                        this.$model.taskOptionList.count() === 0 &&
                        this.$model.taskCurrentList.count() === 0
                    ) {
                        this.$childControllers.get(
                            'UITasksController'
                        ).visible = false;
                    }
                    this._achievementStatus(miniGameType);
                },
                miniGameSpecialСonditions: (
                    AchievementType: AchievementType
                ) => {
                    this._gameLogic.isAchievements(AchievementType);
                },
            },
            queue: {
                tooltip: {
                    condition: (clock: number) => clock > 3,
                    action: () => {
                        this._gameLogic.hideTooltip();
                    },
                },
            },
            modelWatch: {
                tooltipState: async (state: TooltipStateEnum) => {
                    this.removeChildControllerByName('tooltip');

                    if (
                        state !== TooltipStateEnum.none &&
                        this.$model.gameState !== GameStateEnum.gameEnd
                    ) {
                        this.addChildController(
                            {
                                view: UITooltipController,
                                model: this.$model,
                            },
                            'tooltip'
                        );
                        this.$queue.get('tooltip').addToQueue(0);
                    }
                },
            },
        };
    }

    private _achievementStatus(miniGameType: MiniGameTypeEnum): void {
        const activeTask = this.$model.taskCurrentList.where(
            o =>
                o.miniGameType === miniGameType &&
                o.type === TaskType.Regular &&
                !o.active
        );

        if (activeTask.count()) {
            this._gameLogic.isAchievements(AchievementType.Proactivity);
        }
    }

    private _showGlobalTaskTooltip(miniGameType: MiniGameTypeEnum): void {
        const globalTask = this.$model.taskCurrentList.where(
            o => o.miniGameType === miniGameType && o.type === TaskType.Global
        );

        if (globalTask.count()) {
            this._gameLogic.showTooltip(
                TooltipStateEnum.task,
                'Выполни основное задание, иначе оно блокирует остальные'
            );
        }
    }

    protected onInitialize(): void {}

    protected onResize(width: number, height: number, scale: number): void {
        this.x = 0;
        this.y = -height / scale / 2;
    }
}
